import Vue from "vue";
import Vuex from "vuex";
import { mapState } from "vuex";
import storeFilter from "./components/store-product-filter.vue";
import storeProducts from "./components/store-products.vue";

import axios from "axios";
axios.defaults.headers.post["X-CSRF-TOKEN"] = window.csrf_token;

Vue.use(Vuex);

new Vue({
	el: "#app",
	store: window.app.store,
	mounted: function () {
		this.$store.dispatch("fetchProducts");
	},
	components: {
		storeFilter,
		storeProducts,
	},
	data: function () {
		return {
			// data_term:''
		};
	},
	computed: {
		store_term: function () {
			return this.$store.term;
		},
	},
	methods: {
		term: function (e) {
			this.$store.commit("store_term", e.target.value);
		},
		products: function () {
			this.$store.dispatch("fetch_products");
		},
	},
});

// ------------------------------------------

// // require('clientjs/dist/client.min.js');
// //// Create a new ClientJS object
// // var client = new ClientJS();

// //// Get the client's fingerprint id
// // var fingerprint = client.getFingerprint();

// //// Print the 32bit hash id to the console
// // console.log(fingerprint);

import FingerprintJS from "@fingerprintjs/fingerprintjs";

(async () => {
	// We recommend to call `load` at application startup.
	const fp = await FingerprintJS.load();

	// The FingerprintJS agent is ready.
	// Get a visitor identifier when you'd like to.
	const result = await fp.get();

	// This is the visitor identifier:
	const visitorId = result.visitorId;
	console.log(visitorId);
})();
